module.exports = __webpack_public_path__ + "assets/images/school-header.svg?v=276bcc7e";